module.exports = __webpack_public_path__ + "img/ic_32_sport_american_football-white.d21c9cc7.svg";